import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-317d9be8")

_pushScopeId("data-v-317d9be8")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Guide")
const _hoisted_2 = { class: "d-body df-middle" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" It seems that you have a talent for trading, switch to real account and make real profits! ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Pic = _resolveComponent("Pic")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, { style: {"background":"var(--color-primary)"} }, {
    title: _withId(() => [
      _createVNode(_component_t, {
        as: "p",
        path: "trade_23",
        class: "t-text c-white f-lg t-center f-bold",
        style: {"line-height":"24px"}
      }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    right: _withId(() => [
      _createVNode(_component_Icon, {
        name: "close",
        class: "c-white",
        style: {"border-radius":"12px"},
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      })
    ]),
    controls: _withId(() => [
      _createVNode(_component_Button, {
        class: "flex-1 btn button c-btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withId(() => [
          _createVNode(_component_t, {
            path: "notification_33",
            custom: ""
          }, {
            default: _withId(({td}) => [
              _createTextVNode(_toDisplayString(td || 'Later'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "flex-1 btn primary button s-btn",
        onClick: _ctx.deposit
      }, {
        default: _withId(() => [
          _createVNode(_component_t, {
            path: "trade_12",
            custom: ""
          }, {
            default: _withId(({td}) => [
              _createTextVNode(_toDisplayString(td || 'Deposit Now'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Pic, {
          src: "trade/coin",
          width: "88",
          height: "64"
        }),
        _createVNode(_component_t, {
          as: "p",
          path: "trade_24",
          class: "f-md c-white"
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
})